import { ConfigMap } from "../../configMap/interfaces/configmap";
import { CategorizationAnnotation } from "../../configMap/interfaces/category";
import { Annotation } from "../../annotator/interfaces/annotation";
import { AnnotationItem } from "../../documentTypes/interfaces";
import { EntityAnnotation } from "../interfaces/annotation";
import {
  mapBackToCategorizationAnnotations,
  mapBackToEntityAnnotations,
} from "../../documentTypes/utils/synchronizeAnnotationHelper";
import {
  cleanUpTableAnnotationIndexGaps,
  mapAnnotationsToAnnotatorFormat,
} from "./annotationMappers";
import { getSideAndTableControlAnnotationItems } from "./utils";

export type AnnotationView = {
  annotations: Array<Annotation>;
  categorizationAnnotations: Array<CategorizationAnnotation>;
};

/**
 * Turns raw entity annotations into what the detail page renders. Used both for the
 * annotations a document set loads with and for a historical snapshot, so both views
 * go through the same mapping, side/table split and index-gap cleanup.
 */
export const buildAnnotationView = (
  entityAnnotations: Array<EntityAnnotation>,
  categorizationAnnotations: Array<CategorizationAnnotation>,
  configMap?: ConfigMap,
): AnnotationView => {
  const mappedAnnotations = mapAnnotationsToAnnotatorFormat(
    entityAnnotations,
    configMap,
  );

  const annotationItems: Array<AnnotationItem> = [
    ...(mappedAnnotations.map((annotation) => ({
      ...annotation,
      isEntity: true,
    })) as Array<AnnotationItem>),
    ...(categorizationAnnotations.map((annotation) => ({
      ...annotation,
      isEntity: false,
    })) as Array<AnnotationItem>),
  ];

  const { sideControlAnnotations, tableControlAnnotations } =
    getSideAndTableControlAnnotationItems(annotationItems);

  const items = sideControlAnnotations.concat(
    cleanUpTableAnnotationIndexGaps(tableControlAnnotations),
  );

  return {
    annotations: mapBackToEntityAnnotations(items),
    categorizationAnnotations: mapBackToCategorizationAnnotations(items),
  };
};
